import type { SourceType } from "@/features/assets/useFileDropZone";

import * as React from "react";

import { useShopifyFileDropZone } from "@/features/assets/useFileDropZone";
import { Spinner } from "@replo/design-system/components/spinner/Spinner";
import twMerge from "@replo/design-system/utils/twMerge";
import { Plus } from "lucide-react";

// TODO (Gabe 2025-03-13, REPL-16485): Remove this once Shopify uploads (fonts)
// is fully disabled.
const ShopifyFileDropzone: React.FC<{
  projectId: string | null | undefined;
  forceLoading?: boolean;
  onUploadComplete(url: string): void;
  assetContentType?: "image" | "video";
  acceptDropAssetType: string[] | null | undefined;

  sourceType: SourceType;
  inputSize?: "small" | "big";
  dragText?: string;
  uploadText?: string;
  loadingText?: string;
  className?: string;
}> = ({
  forceLoading,
  onUploadComplete,
  assetContentType,
  acceptDropAssetType,
  sourceType,
  inputSize = "big",
  dragText = "Drop to Upload",
  uploadText = "Upload",
  loadingText = "Uploading...",
  className,
}) => {
  const { getRootProps, getInputProps, isDragActive, isUploading } =
    useShopifyFileDropZone({
      sourceType,
      onUploadComplete,
      acceptDropAssetType,
      allowClickToUpload: true,
    });
  const updateOrCreateAssetIsLoading = isUploading || forceLoading;

  return inputSize === "big" ? (
    <div
      {...getRootProps({
        className:
          "h-full flex flex-col justify-center items-center bg-sheet font-medium text-base text-primarycursor-pointer",
      })}
    >
      <input {...getInputProps()} />
      {updateOrCreateAssetIsLoading && <Spinner size={10} variant="primary" />}
      {isDragActive && !updateOrCreateAssetIsLoading && (
        <div className="text-lg">{dragText}</div>
      )}
      {!updateOrCreateAssetIsLoading && !isDragActive && (
        <div className="text-lg">
          Upload {assetContentType === "video" ? "Video" : "Image"}
        </div>
      )}
    </div>
  ) : (
    <div
      {...getRootProps({
        className: twMerge(
          "flex cursor-pointer items-center border-t border-secondary pt-2 text-primary font-medium",
          className,
        ),
      })}
    >
      {isUploading ? (
        <Spinner variant="primary" size={16} />
      ) : (
        <Plus size={18} className="mr-1" />
      )}
      <span
        className={twMerge(
          "text-sm",
          isUploading && "text-muted cursor-not-allowed",
        )}
      >
        <input {...getInputProps()} />
        {(() => {
          if (isUploading) {
            return loadingText;
          }
          if (isDragActive) {
            return dragText;
          }
          return uploadText;
        })()}
      </span>
    </div>
  );
};

export default ShopifyFileDropzone;
